import {makeGorillaApolloClient} from '@wandb/weave/apollo';
import {lazy} from 'react';

import {
  type RunsDataQueryConfig,
  toRunsDataQueryConfig,
} from '../../containers/RunsDataLoader';
import {apolloEndpoint} from '../../util/apollo';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import type {PanelSpec} from '../../util/panelTypes';
import type {Query} from '../../util/queryTypes';
import {
  EVAL_TABLE_MAX_RUNS,
  EVALUATION_TABLES_PANEL_TYPE,
  type EvaluationTablesConfig,
} from './common';

// Singleton apollo client for the evaluation tables panel so we don't create
// a new client for each logged EvaluationTable.
let gorillaApolloClient: ReturnType<typeof makeGorillaApolloClient> | null =
  null;
export function getGorillaApolloClient(): ReturnType<
  typeof makeGorillaApolloClient
> {
  if (gorillaApolloClient == null) {
    gorillaApolloClient = makeGorillaApolloClient(apolloEndpoint);
  }
  return gorillaApolloClient;
}

/**
 * Active runsData required: the inner component reads `runsData.filtered` to
 * resolve workspace runs into eval call ids and to drive the run-slot strip.
 */
const transformQuery = (query: Query): RunsDataQueryConfig => {
  // Eval Tables compare individual runs; grouped rows carry synthetic names
  // that can't match eval traces. Pass `disableGrouping` rather than stripping
  // grouping off the result — toRunsDataQueryConfig drops pinned runs from the
  // filter when it sees a grouped run set.
  return toRunsDataQueryConfig(
    query,
    {disableGrouping: true},
    {
      panelType: EVALUATION_TABLES_PANEL_TYPE,
      page: {size: EVAL_TABLE_MAX_RUNS},
    }
  );
};

const configSpec = {};

export const Spec: PanelSpec<
  typeof EVALUATION_TABLES_PANEL_TYPE,
  EvaluationTablesConfig
> = {
  type: EVALUATION_TABLES_PANEL_TYPE,
  Component: createPreloadableLazyComponent(() => import('./Component'))
    .Component,
  transformQuery,
  configSpec,
  noEditMode: false,
  icon: 'table',
};
